import { render, staticRenderFns } from "./HumanRight.vue?vue&type=template&id=51d8bab2&scoped=true"
import script from "./HumanRight.vue?vue&type=script&lang=js"
export * from "./HumanRight.vue?vue&type=script&lang=js"
import style0 from "./HumanRight.vue?vue&type=style&index=0&id=51d8bab2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d8bab2",
  null
  
)

export default component.exports